// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"108":"a2c4e577","244":"ae0a57da","366":"8e1b887a","411":"7d2e0db6","447":"505a3751","459":"9295f6eb","615":"3309ac99","962":"47ac04a9"}[chunkId] + ".chunk.js";
};